import React from 'react'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'

// @material-ui/icons
import Replay from '@material-ui/icons/Replay'

import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import Button from 'components/CustomButtons/Button.jsx'
import CustomInput from 'components/CustomInput/CustomInput.jsx'

import Clearfix from 'components/Clearfix/Clearfix.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'
import CardIcon from 'components/Card/CardIcon.jsx'

import userProfileStyles from 'assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx'

import { resetPassword } from '../../services/generalServiceAPI'
import AppContext from '../../services/context'
import { logger, compare, verifyMinLength, noError } from '../utility/utility'

import swal from 'sweetalert'

class UserPasswordReset extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      data: {
        tableName: 'users',
        id: '',
        currentPassword: '',
        password: '',
        confirmPassword: ''
      },
      dataState: {
        currentPassword: '',
        passwordState: '',
        confirmPasswordState: ''
      },
      showConfirmedPassword: false,
      showPassword: false
    }

    this.registerClick = this.registerClick.bind(this)
    this.change = this.change.bind(this)
  }
  static contextType = AppContext

  handleClickShowCurrentPassword = e => {
    this.setState(state => ({ showCurrentPassword: !state.showCurrentPassword }))
  }
  handleClickShowPassword = e => {
    this.setState(state => ({ showPassword: !state.showPassword }))
  }
  handleClickShowConfirmedPassword = e => {
    this.setState(state => ({ showConfirmedPassword: !state.showConfirmedPassword }))
  }

  change(event, stateName, type, stateNameEqualTo, maxValue) {
    switch (type) {
      case 'min-length':
        if (verifyMinLength(event.target.value, 8)) {
          this.setState({ dataState: { [stateName + 'State']: 'success' } })
        } else {
          this.setState({ dataState: { [stateName + 'State']: 'error' } })
        }
        break

      case 'equalTo':
        if (compare(event.target.value, this.state.data[stateNameEqualTo])) {
          this.setState({ dataState: { [stateName + 'State']: 'success' } })
        } else {
          this.setState({ dataState: { [stateName + 'State']: 'error' } })
        }
        break
      default:
    }

    this.setState({ data: { ...this.state.data, [stateName]: event.target.value } })
  }
  registerClick() {
    if (this.state.data.password === '') {
      this.setState({ dataState: { passwordState: 'error' } })
    }
    if (this.state.data.confirmpassword === '') {
      this.setState({ dataState: { confirmPasswordState: 'error' } })
    }

    if (noError(this.state.dataState)) {
      const data = {
        id: this.context.user.id,
        username: this.context.user.username,
        currentPassword: this.state.data.currentPassword,
        newPassword: this.state.data.password
      }
      resetPassword(data).then(response => {
        swal('This password has beend updated successfully', {
          icon: 'success'
        })
      })
    } else swal('Please fix the error on the page first.')
  }
  componentDidMount() {
    try {
      // this is cool, the later spreading overrides the previous spreading, so it keeps the data structure and only update the set ones
      this.setState({ data: { ...this.state.data, ...this.props.location.state.user } }, () => {
        logger('PasswordReset: componentDidMount', this.state.data)
      })
    } catch (e) {
      logger('PasswordReset: componentDidMount', e, true)
    }
  }
  render() {
    const { classes } = this.props
    return (
      <div>
        <GridContainer style={{ maxWidth: '500px' }}>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <Replay />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  Reset Password - <small>need your current password</small>
                </h4>
              </CardHeader>
              <CardBody>
                <form>
                  {/**  username and first and last name*/}
                  {/* password line*/}
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Current Password"
                        id="currentPassword"
                        formControlProps={{
                          fullWidth: true
                        }}
                        success={this.state.dataState.currentPasswordState === 'success'}
                        error={this.state.dataState.currentPasswordState === 'error'}
                        inputProps={{
                          disabled: false,
                          value: this.state.data.currentPassword,
                          onChange: event => this.change(event, 'currentPassword', 'max-length', 50),
                          type: this.state.showCurrentPassword ? 'text' : 'password',
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton aria-label="Toggle password visibility" onClick={this.handleClickShowCurrentPassword}>
                                {this.state.showCurrentPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Password"
                        id="password"
                        formControlProps={{
                          fullWidth: true
                        }}
                        success={this.state.dataState.passwordState === 'success'}
                        error={this.state.dataState.passwordState === 'error'}
                        inputProps={{
                          disabled: false,
                          value: this.state.data.password,
                          onChange: event => this.change(event, 'password', 'min-length', 8),
                          type: this.state.showPassword ? 'text' : 'password',
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton aria-label="Toggle password visibility" onClick={this.handleClickShowPassword}>
                                {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="Comfirm Password"
                        id="confirmPassword"
                        formControlProps={{
                          fullWidth: true
                        }}
                        success={this.state.dataState.confirmPasswordState === 'success'}
                        error={this.state.dataState.confirmPasswordState === 'error'}
                        inputProps={{
                          disabled: false,
                          value: this.state.data.confirmPassword,
                          onChange: event => this.change(event, 'confirmPassword', 'equalTo', 'password'),
                          type: this.state.showConfirmedPassword ? 'text' : 'password',
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton aria-label="Toggle password visibility" onClick={this.handleClickShowConfirmedPassword}>
                                {this.state.showConfirmedPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                      />
                    </GridItem>
                  </GridContainer>

                  <Button color="rose" className={classes.updateProfileButton} onClick={this.registerClick}>
                    Reset Password
                  </Button>
                  <Clearfix />
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}

export default withStyles(userProfileStyles)(UserPasswordReset)
